/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Push_NotificationsInputs */

const en_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Notifications`)
};

const es_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones Push`)
};

const fr_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications Push`)
};

const de_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-Benachrichtigungen`)
};

const ja_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知`)
};

const zh_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推送通知`)
};

const ar_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشعارات الدفع (Push)`)
};

const id_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi Push`)
};

const it_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche Push`)
};

const ru_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-уведомления`)
};

const pt_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações Push`)
};

const ko_settings_push_notifications = /** @type {(inputs: Settings_Push_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림`)
};

/**
* | output |
* | --- |
* | "Push Notifications" |
*
* @param {Settings_Push_NotificationsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_push_notifications = /** @type {((inputs?: Settings_Push_NotificationsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Push_NotificationsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_push_notifications(inputs)
	if (locale === "es") return es_settings_push_notifications(inputs)
	if (locale === "fr") return fr_settings_push_notifications(inputs)
	if (locale === "de") return de_settings_push_notifications(inputs)
	if (locale === "ja") return ja_settings_push_notifications(inputs)
	if (locale === "zh") return zh_settings_push_notifications(inputs)
	if (locale === "ar") return ar_settings_push_notifications(inputs)
	if (locale === "id") return id_settings_push_notifications(inputs)
	if (locale === "it") return it_settings_push_notifications(inputs)
	if (locale === "ru") return ru_settings_push_notifications(inputs)
	if (locale === "pt") return pt_settings_push_notifications(inputs)
	return ko_settings_push_notifications(inputs)
});